import { css } from 'linaria';
import { searchOverlay } from 'styles/z-indexs';

export const pseudoInputContent = css`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  letter-spacing: 0.05px;
`;

export const pseudoInput = css`
  display: flex;
  justify-content: flex-start !important;
  column-gap: var(--space-100);
  padding: var(--space-125) var(--space-200) !important;
  border-radius: var(--rounding-m) !important;
  width: 100%;
  background-color: var(--control-minor) !important;
  color: var(--text-primary_opacity-8);

  @media (hover: hover) {
    &:hover {
      background-color: var(--control_hover-minor) !important;
    }
  }

  &[hidden] {
    opacity: 0;
  }
`;

export const searchbarInput = css`
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.05px;
  padding: var(--space-150) var(--space-200);

  width: 100%;
  font-weight: 400;
  font-family: inherit;
  border: none;
  border-radius: var(--rounding-m);
  transition: background 0.3s ease-out, transform 0.3s cubic-bezier(0.24, 0.81, 0.2, 0.96);
  -webkit-appearance: none;
  appearance: none;
  -webkit-tap-highlight-color: transparent;
  background-color: var(--control-minor) !important;
  caret-color: var(--brand-dark);

  &::-ms-clear {
    display: none;
    width: 0;
    height: 0;
  }

  &::-ms-reveal {
    display: none;
    width: 0;
    height: 0;
  }

  &::-webkit-input-placeholder {
    font-weight: 400;
    font-size: 16px;
    font-family: inherit;
    line-height: 24px;
    color: var(--text-primary_opacity-8);
  }

  &::-moz-placeholder {
    font-weight: 400;
    font-size: 16px;
    font-family: inherit;
    line-height: 24px;
    color: var(--text-primary_opacity-8);
  }

  &::-webkit-search-decoration,
  &::-webkit-search-cancel-button,
  &::-webkit-search-results-button,
  &::-webkit-search-results-decoration {
    display: none;
  }

  &:-ms-input-placeholder {
    font-weight: 400;
    font-size: 16px;
    font-family: inherit;
    line-height: 24px;
    color: var(--text-primary_opacity-8);
  }

  &:focus {
    outline: none;
  }
`;

export const searchClear = css`
  display: none !important;
  align-items: center;

  &.show {
    display: flex !important;
  }

  @media (hover: hover) {
    &:hover {
      background: none;
    }
  }
`;

export const pseudoInputIcon = css`
  display: flex;
  align-items: center;
  overflow: hidden;
`;

export const modalOverlay = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: none;
  width: 100%;
  height: 100%;

  background: var(--background-accent);
  opacity: var(--opacity-8);
  z-index: ${searchOverlay};
`;

export const active = css`
  display: block;
`;

export const preloaderItem = css`
  --p-space: 200px;
  --p-space-2: 320px;

  @media (--to-tablet) {
    --p-space: 48px;
    --p-space-2: 120px;
  }

  position: relative;
  height: var(--space-600);

  @keyframes progress {
    from {
      background-position-x: 0%;
    }
    to {
      background-position-x: 100%;
    }
  }

  &::after {
    position: absolute;
    content: '';
    top: var(--space-175);
    bottom: var(--space-175);
    width: calc(100% - var(--p-space));
    left: var(--space-175);
    border-radius: var(--rounding-m);

    background: linear-gradient(
      90deg,
      var(--background-secondary),
      var(--background-primary),
      var(--background-secondary)
    );
    background-size: 50%;
    animation: progress 1s linear infinite;
  }

  &:nth-child(2n) {
    &::after {
      width: calc(100% - var(--p-space-2));
    }
  }
`;
